/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FunctionComponent } from 'react'
import styled from 'styled-components/native'

import { hiddenFromScreenReader } from 'shared/accessibility/helpers/hiddenFromScreenReader'
import { HiddenAccessibleText } from 'ui/components/HiddenAccessibleText'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { PasswordRule } from 'ui/designSystem/PasswordInput/components/PasswordRule'
import {
  getPasswordRuleStatus,
  getPasswordRulesAccessibilityLabel,
  DISPLAYED_PASSWORD_RULES,
} from 'ui/designSystem/PasswordInput/helpers'

type Props = {
  password: string
  visible?: boolean
}

export const PasswordRules: FunctionComponent<Props> = ({ password, visible }) => {
  const hiddenAccessibleText = getPasswordRulesAccessibilityLabel(password)

  if (visible)
    return (
      <React.Fragment>
        <HiddenAccessibleText displayBlock>{hiddenAccessibleText}</HiddenAccessibleText>
        <RulesContainer {...hiddenFromScreenReader()} gap={1}>
          {DISPLAYED_PASSWORD_RULES.map((rule) => (
            <PasswordRule
              key={rule.key}
              title={rule.label}
              status={getPasswordRuleStatus(password, rule.test)}
            />
          ))}
        </RulesContainer>
      </React.Fragment>
    )

  return null
}

const RulesContainer = styled(ViewGap)(({ theme }) => ({
  alignItems: 'flex-start',
  width: '100%',
  maxWidth: theme.forms.maxWidth,
  paddingTop: theme.designSystem.size.spacing.s,
}))
